/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentLogDto } from '../models/DocumentLogDto';
import type { DocumentsLogsCategoryEnum } from '../models/DocumentsLogsCategoryEnum';
import type { DocumentsLogsDtoPagedListData } from '../models/DocumentsLogsDtoPagedListData';
import type { SortTypeEnum } from '../models/SortTypeEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentsLogsService {

  /**
   * @param search 
   * @param startDate 
   * @param endDate 
   * @param categoryId
 *
 * 1 = Sales
 *
 * 2 = Aftersales
 *
 * 3 = PoliciesAndProcedures
 *
 * 4 = Parts
 *
 * 5 = Templates
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns DocumentsLogsDtoPagedListData Success
   * @throws ApiError
   */
  public static getDocumentsLog(
search?: string,
startDate?: string,
endDate?: string,
categoryId?: DocumentsLogsCategoryEnum,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<DocumentsLogsDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents-log',
      query: {
        'Search': search,
        'StartDate': startDate,
        'EndDate': endDate,
        'CategoryId': categoryId,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param id 
   * @returns DocumentLogDto Success
   * @throws ApiError
   */
  public static getDocumentsLogDocumentLogs(
id: number,
): CancelablePromise<DocumentLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/documents-log/document-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteDocumentsLogDocumentLogs(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/documents-log/document-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postDocumentsLogDocumentLogs(
formData?: {
Id?: number;
GroupName: string;
CategoryId?: number;
Files?: Array<Blob>;
DeleteItems?: Array<number>;
VideoLinks?: Array<string>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/documents-log/document-logs',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Upload Video
   * @param id 
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postDocumentsLogVideos(
id: number,
formData?: {
Video: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/documents-log/{id}/videos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param videoId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDocumentsLogVideos(
id: number,
videoId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/documents-log/{id}/videos/{videoId}',
      path: {
        'id': id,
        'videoId': videoId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param itemId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteDocumentsLogItems(
id: number,
itemId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/documents-log/{id}/items/{itemId}',
      path: {
        'id': id,
        'itemId': itemId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
